export default __webpack_public_path__ + "static/media/landscape.75035960.png";